import { TypeUsuario } from "../Usuario"
import { TypeEmail } from "./Contato/Email"
import { TypeTelefone } from "./Contato/Telefone"
import { DadosBancario } from "./DadosBancario"
import { TypeEndereco } from "./Endereco"

import { Dayjs } from "dayjs"
import PessoaBloqueio from "./PessoaBloqueio"

export enum EnumPessoaTipo {
    EMPRESA = 1,
    REPRESENTANTE = 2,
    FORNECEDOR = 3,
    TRANSPORTADORA = 4,
    CLIENTE = 5,
    USUARIO = 6,
    ESCOLA = 7,
    RESPONSAVEL = 8,
    ALUNO = 9
}

export enum EnumTipoConsumidor {
    REVENDA = 1,
    USO_E_CONSUMO = 2,
    CONSUMIDOR_FINAL = 3
}

export type TypeSegmentoAtuacao = {
    codigo?: number,
    descricao?: string,
    tipoPessoa?: EnumPessoaTipo
}

export type TypeMateriaisServicos = {
    codigo?: number,
    descricao?: string
}

export type TypePessoa = {
    codigo?: number,

    cpf?: string,
    cnpj?: string,
    passaporte?: string,
    rne?: string,

    documentoExibicao?:string,

    tipo?: EnumPessoaTipo,
    tipoConsumidor?: EnumTipoConsumidor,

    nome?: string,
    nomeSocial?: string,
    // sexo?: string,

    codGenero ?: number;
    descricaoGenero ?: string;
    generoExibicao ?: string;
    bloqueios?:PessoaBloqueio[];

    readonly nomeExibicao?: string,

    site?: string,
    segmentoAtuacao?: TypeSegmentoAtuacao,
    materialServicoPrestado?: TypeMateriaisServicos,
    descricaoMaterialServicoPrestado?: string

    inscricaoEstadual?: string,
    inscricaoMunicipal?: string,
    inscricaoSuframa?: string,

    chavePIX?: string,

    diasParaBloqueioDeInadimplentes?:number,

    usuario?: TypeUsuario,

    enderecos?: TypeEndereco[],
    telefones?: TypeTelefone[],
    emails?: TypeEmail[],
    dadosBancarios?: DadosBancario[];

    ativo?: boolean,
    dataRegistro?: string | Date | Dayjs,

}

export type TypePessoaObfuscada = {
    cpf?: string,
    nome?: string
}

export function extractorNomePessoa(pessoa:TypePessoa) : string {
    return (pessoa.nomeSocial?.length ?? 0) > 0 ? pessoa.nomeSocial! : pessoa.nome!;
}

export enum EnumDocumentoTipo {
    CPF = 1,
    CNPJ,
    Passaporte,
    RNE
}